<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <span v-if="task.taskStatus ==='SuccessfullyCompleted'">
                        <h1>Identity Verification Complete</h1>
                        <p>The identity verification checks for the persons with significant control in your business have been completed.</p>
                    </span>
                    <span v-else-if="task.taskStatus =='CompletedWithWarnings'">
                        <h1>Investigation Required!</h1>
                        <p>The identity verification checks for the persons with significant control in your business have been completed. The verification service has identified potential issues that require further investigation.</p>
                        <p>Please review the results of any identification check that requires your attention and when you're happy click 'Resolve' to confirm that you are happy to proceed.</p>
                    </span>
                    <span v-else>
                        <h1>Identity Verification</h1>
                        <p>We have identified the below people as persons with significant control for your business from Companies House. </p>
                        <p>We require a Know Your Customer (KYC) check to be performed on these individuals to meet our anti-money laundering obligations. </p>
                    </span>
                </div>
                <div class="cell small-12">
                    <table>
                    <thead>
                        <tr>
                        <th>Email Address</th>
                        <th>Verification Status</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(verification, idx) in verifications" :key="idx">
                            <td data-label="EmailAddress">{{ verification.email }}</td>
                            <td data-label="VerificationStatus" v-if="identity.type == 'Administrator'">{{ displayVerificationStatus(verification.taskStatus) }} 
                                <span v-if="verification.taskStatus === 'CompletedWithWarnings'">
                                    - 
                                    <a :href="`${trustIdBaseUrl}/#/home/checks/details?applicationId=${verification.id}`" target="_blank">
                                        <span style="text-decoration:underline">view results now</span></a>
                                </span>  
                                <span v-if="verification.taskStatus === 'SuccessfullyCompleted'">
                                    <a :href="`${trustIdBaseUrl}/#/home/checks/details?applicationId=${verification.id}`" target="_blank">
                                        <span style="text-decoration:underline">view results now</span></a>
                                </span>
                            </td>
                            <td data-label="ResolutionReason" v-if="identity.type == 'Administrator'">
                                {{ verification.verificationCheckResolution?.resolutionComment }}
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>

            </div>
            <br/>
            <textarea
                v-model="resolutionReason"
                style="height: 220px;"
                placeholder="Provide the reasons for resolving the warnings. This information will be used to evidencing our decision in the future if a review is required."
                v-if="task.taskStatus === 'CompletedWithWarnings'"
            />
            <br/>
            <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
            <button class="btn btn-primary" v-if="task.taskStatus === 'CompletedWithWarnings'"  @click="investigationResolved()">Investigation Resolved</button>
        </section>

        


</div>


  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getVerificationCheckTask, putVerificationCheckTask, postVerificationResolution } from '@/services/implementationmanagement.api';
import { splitByCapitals } from '@/helpers/strings';

const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const verifications = ref(null);
const task = ref(null);

const resolutionReason = ref('');

const errorString = 'An error has occurred. Please contact your Qtac account manager.';

const trustIdBaseUrl = process.env.VUE_APP_THIRDPARTY_TRUSTID;

import { useIdentityStore } from '@/stores/identity';

const identity = useIdentityStore();

onMounted(async () => {

    try {

        var taskResponse = await getVerificationCheckTask(taskId);

        if(taskResponse.status !== 200 || taskResponse.data === null || taskResponse.data === undefined) {
            error.value = errorString;
            return null;
        }

        task.value = taskResponse.data;

        if(taskResponse.data.individualChecks == null)
        {
            error.value = errorString;
            return null;
        }

        verifications.value = taskResponse.data.individualChecks;


    } catch (err) {
        error.value = errorString;
        console.error(err);
    }




loaded.value = true;
})



function displayVerificationStatus(status) {
    if (!status) return '';

    if(status === 'CompletedWithWarnings') return 'Warnings returned'

    return splitByCapitals(status)

}

async function investigationResolved() {
    try {
        const resolutionDate = new Date().toISOString();
        const resolvedBy = identity.account.name;

        const checksWithWarnings = task.value.individualChecks.filter(
            check => check.taskStatus === 'CompletedWithWarnings'
        );

        // Create a resolution for each check with warnings
        await Promise.all(
            checksWithWarnings.map(check => {
                const resolution = createResolution(
                    check,
                    resolutionReason.value,
                    resolutionDate,
                    resolvedBy
                );

                return postVerificationResolution(resolution);
            })
        );

        // Update the parent task status
        task.value.taskStatus = 'SuccessfullyCompleted';

        await putVerificationCheckTask(taskId, task.value);

        router.push({ name: 'Home' });

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }
}

function createResolution(checkTask, resolutionComment, resolutionDate, resolvedBy)
{
    return {
        verificationCheckTaskId: checkTask.taskId,
        resolutionComment: resolutionComment,
        resolutionDate: resolutionDate,
        resolvedBy: resolvedBy
    };
}


</script>

